import styled from "@emotion/styled";
import { genericStyles } from "../../../constant";

export const StyledSignupContainer = styled.div`
  width: 100%;
  padding: 0px 20px;
  .signup-div {
    max-height: 80dvh;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .submit-button {
    width: 100%;
  }

  /* OTP Verification Styles */
  .otp-container {
    text-align: center;
  }

  .otp-icon {
    width: 80px;
    height: 80px;

    font-size: 36px;
    color: #ffffff;
  }

  .otp-title {
    font-size: 28px;
    font-weight: 600;
    margin: 20px 0px 8px 0px;
  }

  .otp-subtitle {
    font-size: 14px;
    margin-bottom: 32px;
  }

  .otp-email {
    font-size: 14px;
    margin-top: 3px;
    font-weight: 500;
  }

  .otp-input-wrapper {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-bottom: 24px;

    @media (max-width: 576px) {
      gap: 8px;
    }
  }

  .otp-timer {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 16px;
  }

  .timer-text {
    color: ${genericStyles.primaryColor};
    font-weight: 500;
  }

  .ant-otp-input-wrapper {
    width: 38px;
  }

  .success-icon {
    width: 80px;
    height: 80px;
    background: #52c41a;
    font-size: 40px;
    color: #ffffff;
  }

  .success-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 8px;
    margin-top: 20px;
  }

  .success-message {
    font-size: 15px;
    margin-bottom: 32px;
  }
`;
